import { ProgressSpinner } from 'primereact/progressspinner';
import './PageLoader.css';

export default function PageLoader({ className = '', compact = false, label = 'Loading' }) {
  const classes = [
    'page-loader',
    compact ? 'page-loader--compact' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <div className={classes} aria-busy="true" aria-label={label}>
      <ProgressSpinner />
    </div>
  );
}
